import Vue from 'vue';
import {HomeData} from '@/module/home/entities/home-data';
import {OpenDetail} from '@/module/home/entities/open-detail';
import {CityTreeItem} from '@/module/home/entities/city-tree-item';
import {ApiResponse} from '@/module/home/entities/api-response';
import {XinMessage} from '@xin/xin-ui';

class HomeApiService {

  /**
   * 返回值统一处理
   * @param response
   * @param successMsg
   */
  private responseHandler(response: any, successMsg?: boolean): ApiResponse {
    const result = response.data as ApiResponse;
    if (!result.status) {
      XinMessage.error(result.message);
    } else if (successMsg) {
      XinMessage.success(result.message);
    }
    return result;
  }

  /**
   * 获取对接渠道开关
   */
  public getOpenDetail(): Promise<OpenDetail> {
    return Promise.all([
      Vue.http.post('/parrot/service/support/ajax-get-open-dtalk')
        .then(response => response.data),
      Vue.http.post('/parrot/service/support/ajax-get-open-qywx')
        .then(response => response.data),
      Vue.http.post('/parrot/service/support/ajax-get-open-yzj')
        .then(response => response.data)
    ]).then((resultArray) => {
      const [dtalkData, isOpenQywx, isOpenYzj] = resultArray;
      return {
        isOpenDtalk: dtalkData.data.isOpenDtalk && dtalkData.data.isOpenDtalk === '1',
        isOpenQywx: isOpenQywx.data.isOpenQywx && isOpenQywx.data.isOpenQywx === '1',
        isOpenYzj: isOpenYzj.data.isOpenYzj && isOpenYzj.data.isOpenYzj === '1'
      };
    });
  }

  /**
   * 获取审批设置列表-new
   */
   public ajaxGetApplyList (): Promise<HomeData> {
    return Vue.http.get('/employee-pc/service/applyPC/ajax-get-apply-list').then(response => {
      const result = response.data;
      if (!result.status) {
        return '';
      }
      return result.data;
    });
  }

  /**
   * 获取首页背景图-new
   */
   public ajaxGetHomePageBg(): Promise<HomeData> {
    return Vue.http.get('/xsearch/service/admin/home/ajaxGetHomePageBackground').then(response => {
      const result = response.data;
      if (!result.status) {
        return '';
      }
      return result.data;
    });
  }

  /**
   * 获取首页卡片筛选标签列表-new
   */
  public ajaxGetLabelList(): Promise<HomeData> {
    return Vue.http.get('/xsearch/service/admin/home/ajaxGetWorkHomeTabLabels').then(response => {
      const result = response.data;
      if (!result.status) {
        return '';
      }
      return result.data;
    });
  }

  //获取发薪日
  getSalaryDay(){
    return Vue.http.get('/xsearch/service/admin/home/ajaxGetPayDay').then(response => {
      const result = response.data;
      if (!result.status) {
        return '';
      }
      return result.data;
    });
  }

  //获取年假调休
  public getAvailableSurplusDay(): Promise<HomeData> {
    return Vue.http.get('/xsearch/service/admin/home/ajaxGetAvailableSurplusDay').then(response => {
      const result = response.data;
      if (!result.status) {
        return '';
      }
      return result.data;
    });
  }

  /**
   * 获取首页右侧员工统计数字-new
   */
  public ajaxGetEmployeeStatisticsCount (date:string): Promise<HomeData> {
    return Vue.http.get('/xsearch/service/admin/home/ajaxGetEverydayStatistics',{params:{date}}).then(response => {
      const result = response.data;
      if (!result.status) {
        return '';
      }
      return result.data;
    });
  }

  /**
   * 获取考勤日历-new
   */
   public ajaxGetAttendanceCalendar (url:string,postData:any): Promise<HomeData> {
    return Vue.http.post(url,postData).then(response => {
      const result = response.data;
      if (!result.status) {
        return '';
      }
      return result.data;
    });
  }

  /**
   * 获取考勤日历每天详情数据-new
   */
  ajaxGetAttendanceCalendarDetail(postData:any): Promise<HomeData> {
    return Vue.http.post('/employee-pc/service/attendancePC/ajax-get-attendance-record-by-date',postData).then(response => {
      const result = response.data;
      if (!result.status) {
        return '';
      }
      return result.data;
    });
  }

  /**
   * 获取考勤日历每天申请数据-new
   */
   ajaxGetAttendanceCalendarApproveflow(postData:any): Promise<HomeData> {
    return Vue.http.post('/employee-pc/service/attendancePC/ajax-get-approve-bdk-flow',postData).then(response => {
      const result = response.data;
      if (!result.status) {
        return '';
      }
      return result.data;
    });
  }

  /**
   * 获取考勤日历每天备忘提醒数据-new
   */
   ajaxGetAttendanceCalendarReminder(postData:any): Promise<HomeData> {
    return Vue.http.post('/xsearch/service/admin/home/ajaxGetSchedule',postData).then(response => {
      const result = response.data;
      if (!result.status) {
        return '';
      }
      return result.data;
    });
  }

  /**
   * 添加备忘
   * @param postData
   */
   public addReminder(postData: object) {
    return Vue.http.post('/xsearch/service/admin/home/ajax-add-homepage-reminder', postData)
      .then(this.responseHandler);
  }

  /**
   * 编辑备忘
   * @param postData
   */
  public updateReminder(postData: object) {
    return Vue.http.post('/xsearch/service/admin/home/ajax-update-homepage-reminder', postData)
      .then(this.responseHandler);
  }

  /**
   * 删除备忘
   * @param reminderId
   */
  public deleteReminder(reminderId: string) {
    return Vue.http.post('/xsearch/service/admin/home/ajax-delete-homepage-reminder', {reminderId})
      .then(this.responseHandler);
  }

  //-------------------------------计算器相关 start----------------------------------
  /**
   * 获取城市列表
   */
   public getCityTree(name: string, insuranceCity: number): Promise<CityTreeItem[]> {
    return Vue.http.post('/support/service/support/ajax-search-citys', {name, insuranceCity})
      .then(result => {
        if (result.data.status) {
          return result.data.data.data.map((i: any) => {
            return {
              label: i.name,
              value: i.id,
              children: i.districtModels.map((j: any) => {
                return {
                  label: j.name,
                  value: j.id
                } as CityTreeItem;
              })
            } as CityTreeItem;
          });
        } else {
          return [];
        }
      });
  }

  /**
   * 获取地区社保基础参数
   * @param areaId
   * @param residenceType
   */
  public getCalculatorInitParams(areaId: number, residenceType?: number) {
    return Vue.http.post('/payroll/service/ajax-get-calculator-init-params', {areaId, residenceType})
      .then(this.responseHandler);
  }

  /**
   * 员工成本计算
   * @param isBeforeTax 是否是税前工资反推
   * @param postData
   */
  public employeeCostCount(isBeforeTax: boolean, postData: object) {
    return Vue.http.post(isBeforeTax ? '/payroll/service/ajax-salary-predict' : '/payroll/service/ajax-employee-cost', {param: JSON.stringify(postData)})
      .then(this.responseHandler);
  }

  /**
   * 获取社保户籍类型
   * @param areaId
   * @param submit
   */
  public getResidenceType(areaId: number, submit: number) {
    return Vue.http.post('/payroll/service/ajax-get-residence-type', {areaId, submit})
      .then(this.responseHandler);
  }

  /**
   * 获取期权计算参数
   */
  public getStockInitParams() {
    return Vue.http.post('/payroll/service/ajax-get-stock-init-params')
      .then(this.responseHandler);
  }

  /**
   * 期权计算
   */
  public stockSward(posData: object) {
    return Vue.http.post('/payroll/service/ajax-stock-award', {param: JSON.stringify(posData)})
      .then(this.responseHandler);
  }

  //-------------------------------计算器相关 end----------------------------------

  /**
   * 获取合同剩余时间
   */
   public getContractDays() {
    return Vue.http.post('/company/service/ajax-get-contract-days')
      .then(this.responseHandler);
  }

  //从快捷入口进来时 判断是否设置计薪周期
  public getAttendanceListRenderData() {
    return Vue.http.get('/attendance/service/ajax-get-list-render-data');
  }

  // 获取外链
  public getAppLinks() {
    return Vue.http.post('/account-center/service/sso/ajax-get-appLinks',{ linkType:'1'}).then(this.responseHandler);
  }

  // 快捷方式
  public ajaxGetHomeFunction() {
    return Vue.http.get('/aim/web/copilot/ajax-get-home-function').then(this.responseHandler);
  }
}

export const HomeApi = new HomeApiService();
